import "./crossSelling.css";
import "../../ReferEarn/comopnents/refer.css";
import { CSSProperties, useContext, useEffect, useRef, useState } from "react";
import QuestContext from "../../../../components/QuestWrapper";
import General from "../../../../general";
import {
  grabDealIcon,
  grabDealIcon2,
} from "../../../../components/expansion/Svg";
import { PrimaryButton } from "../../../../components/Modules/PrimaryButton";
import Label from "../../../../components/Modules/Label";
import { Input } from "../../../../components/Modules/Input";
import { SecondaryButton } from "../../../../components/Modules/SecondaryButton";
import QuestLabs from "../../../../components/QuestLabs";
import CrossSellingThemeManager from "./CrossSellingThemeManager";
import { BrandTheme, QuestThemeData } from "./CrossSellingType";
import { Gift, Percentage } from "./SVG";

export interface referProp {
  questId: string;
  headingColor?: string;
  userId: string;
  token: string;
  color?: string;
  bgColor?: string;
  heading?: string;
  description?: String;
  shareButtonText?: string;
  iconColor?: string;
  gradientBackground?: boolean;
  primaryHeading?: string;
  primaryDescription?: string;
  showDays?: boolean;
  expiryDate?: number;
  claimRewardHandler?: Function;
  backButtonTrigger?: Function;
  uniqueEmailId?: string;
  uniqueUserId?: string;
  BrandTheme?: BrandTheme;
  QuestThemeData?: QuestThemeData;
  Icon?: "gift" | "percentage";
  isEmail?: boolean;
  footerText?: string;
  styleConfig?: {
    Form?: CSSProperties;
    BackgroundWrapper?: CSSProperties;
    Heading?: CSSProperties;
    Description?: CSSProperties;
    PrimaryButton?: CSSProperties;
    SecondaryButton?: CSSProperties;
    gradientHeading?: CSSProperties;
    gradientDescription?: CSSProperties;
    Input?: CSSProperties;
    Timer?: {
      primaryColor?: string;
      secondaryColor?: string;
      backgroundColor?: string;
      TimerCard?: CSSProperties;
    };
    Footer?: {
      FooterStyle?: CSSProperties;
      FooterTextStyle?: CSSProperties;
      FooterIcon?: CSSProperties;
      FooterText?: string;
    };
    Icon?: CSSProperties;
    Label?: CSSProperties;
    EmailError?: {
      text?: string;
      errorStyle?: CSSProperties;
    };
  };
  showFooter?: boolean;
  variation?: string;
  footerLink?: string;
  gradientBackgroundColor?: string;
}
const CrossSellingOffline = ({
  heading = "50% off on limited products",
  description = "Grab deals before they go off!!!",
  shareButtonText = "Avail now",
  gradientBackground = false,
  primaryHeading = "Grab your deal",
  primaryDescription = "Welcome back, Please complete your details",
  showDays = false,
  expiryDate = 0,
  claimRewardHandler = (email?: string) => {},
  backButtonTrigger = () => {},
  styleConfig,
  BrandTheme,
  QuestThemeData,
  showFooter = true,
  isEmail = false,
  footerText = "Powered by PLG OS",
  footerLink,
  Icon = "gift",
  gradientBackgroundColor,
}: referProp) => {
  const { apiType, themeConfig } = useContext(QuestContext.Context);
  const [email, setEmail] = useState("");
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const requestRef = useRef<number>(expiryDate);
  const GeneralFunctions = new General("mixpanel", apiType);

  const themeManager = new CrossSellingThemeManager(
    themeConfig,
    styleConfig,
    QuestThemeData,
    BrandTheme
  );

  const animate = () => {
    const currentTime = Date.now();
    const remainingTime = requestRef.current - currentTime;
    if (remainingTime <= 0) {
      setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }

    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor(
      (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

    setTimeLeft({ days, hours, minutes, seconds });
    requestAnimationFrame(animate);
  };

  useEffect(() => {
    requestRef.current = expiryDate;
    animate();
    return () => cancelAnimationFrame(requestRef.current);
  }, [expiryDate]);

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return email ? emailRegex.test(email.trim()) : false;
  };

  const renderTimer = () => (
    <div className="q_time_left">
      {showDays && !!timeLeft.days && (
        <div
          className="q_hours_left"
          style={themeManager.getTimerStyles().card}
        >
          <div style={themeManager.getTimerStyles().primaryText}>
            {timeLeft.days}
          </div>
          <div
            className="q_time_left_text"
            style={themeManager.getTimerStyles().secondaryText}
          >
            Days
          </div>
        </div>
      )}
      {["hours", "minutes", "seconds"].map((unit) => (
        <div
          key={unit}
          className={`q_${unit}_left`}
          style={themeManager.getTimerStyles().card}
        >
          <div style={themeManager.getTimerStyles().primaryText}>
            {timeLeft[unit as keyof typeof timeLeft] < 10 ? "0" : ""}
            {timeLeft[unit as keyof typeof timeLeft]}
          </div>
          <div
            className="q_time_left_text"
            style={themeManager.getTimerStyles().secondaryText}
          >
            {unit.charAt(0).toUpperCase() + unit.slice(1)}
          </div>
        </div>
      ))}
    </div>
  );

  const renderEmailInput = () =>
    isEmail && (
      <div style={{ width: "100%" }}>
        <Label
          htmlFor="normalInput"
          children="Email Address"
          style={themeManager.getInputStyles().label}
        />
        <Input
          type="email"
          style={themeManager.getInputStyles().input}
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          emailtext={themeManager.getInputStyles().error.text}
          emailErrorStyle={themeManager.getInputStyles().error.style}
        />
      </div>
    );

  const renderMainContent = () => (
    <div
      className="q_refer_and_earn"
      style={themeManager.getMainContentStyles()}
    >
      <div className="q_refer_head">
        {Icon == "gift" ? <Gift primary={themeManager.getIconColor().primary} secondary={themeManager.getIconColor().primary} /> : <Percentage primary={themeManager.getIconColor().primary} secondary={themeManager.getIconColor().secondary} tertiary={themeManager.getIconColor().tertiary} />}
      </div>
      <div className="q_refer_content">
        <div className="refer_content_box">
          <div
            className="q_refer_heading"
            style={themeManager.getHeadingStyles()}
          >
            {heading}
          </div>
          <div
            className="q_refer_desc"
            style={themeManager.getDescriptionStyles()}
          >
            {description}
          </div>
        </div>
        {renderTimer()}
        {renderEmailInput()}
        <PrimaryButton
          style={themeManager.getPrimaryButtonStyles()}
          onClick={() => {
            GeneralFunctions.fireTrackingEvent(
              "quest_challenges_primary_btn_clicked",
              "challenges"
            );
            claimRewardHandler(email);
          }}
          className="q_share_link_button"
          disabled={isEmail && !validateEmail(email)}
        >
          {shareButtonText}
        </PrimaryButton>
        <SecondaryButton
          style={themeManager.getSecondaryButtonStyles()}
          onClick={() => {
            GeneralFunctions.fireTrackingEvent(
              "quest_challenges_secondary_btn_clicked",
              "challenges"
            );
            backButtonTrigger();
          }}
          className="q_share_link_button_2"
        >
          Go to home
        </SecondaryButton>
      </div>
      {!gradientBackground && showFooter && (
        <QuestLabs
          style={themeManager.getFooterStyles().container}
          textStyle={themeManager.getFooterStyles().text}
          iconStyle={themeManager.getFooterStyles().icon}
          text={footerText}
          link={footerLink}
        />
      )}
    </div>
  );

  if (gradientBackground) {
    const gradientStyles = themeManager.getGradientStyles();
    return (
      <div style={gradientStyles.wrapper}>
        <div
          className="q_gradient_background"
          style={gradientStyles.background}
        >
          <div className="q_gradient_head">
            <div className="q_gradient_heading" style={gradientStyles.heading}>
              {primaryHeading}
            </div>
            <div
              className="q_gradient_description"
              style={gradientStyles.description}
            >
              {primaryDescription}
            </div>
          </div>
          {renderMainContent()}
          <div className="q_gradient_quest_powered">
            {showFooter && (
              <QuestLabs
                style={themeManager.getFooterStyles().container}
                textStyle={themeManager.getFooterStyles().text}
                iconStyle={themeManager.getFooterStyles().icon}
                text={footerText}
                link={footerLink}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  return renderMainContent();
};

export default CrossSellingOffline;
